import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'
import axios from 'axios'
const titleSuffix = '- GoChat'

Vue.use(Router)

// let router = new Router({
export default new Router({
  mode: 'history',
  routes: [
    //   {
    //   path: '*',
    //   component: () => import('@/components/auth/Index'),
    //   redirect: () => {
    //     return '/login'
    //   }
    // },
    // {
    //   path: '/',
    //   component: () => import('@/components/auth/Index'),
    //   redirect: () => {
    //     // if (store?.state?.isLogged) {
    //     //   return '/dashboard'
    //     // } else {
    //     return '/login'
    //     // }
    //   }
    // },
    {
      path: '/home',
      beforeEnter : checkAuth,
      component: () => import('@/components/home/Index.vue'),
      name: 'home',
      meta: { title: 'Home', suffix: titleSuffix, name: 'Home', link: 'chat.all' }
    },
    {
      path: '/settings',
      beforeEnter : checkAuth,
      component: () => import('@/components/settings/Index.vue'),
      name: 'settings',
      meta: {
        title: 'Settings',
        suffix: titleSuffix,
        name: 'Settings',
        link: 'settings',
        breadcrumb: [
          { name: "Settings", link: "/settings" },
        ],
      }
    },
    {
      path: '/settings/facebook-event-method',
      name: 'settings.facebookeventmethod',
      beforeEnter : checkAuth,
      component: () => import('@/components/settings/facebook-event-method/ListIndex.vue'),
      meta: {
        // layout: 'social-layout',
        // header: true,
        // title: 'Reports',
        // icon: '',
        // breadcrumb: [
        //   { name: 'Reports', link: "/reports" },
        //   { name: 'Conversions API Report' }
        // ],
        // suffix: titleSuffix
        title: '_Advertise.Facebook Event Method',
        suffix: titleSuffix,
        name: 'Facebook Event Method',
        link: 'settings/facebook-event-method',
        breadcrumb: [
          { name: "Settings", link: "/settings" },
          { name: "_Advertise.Facebook Event Method", link: "/settings/facebook-event-method" },
        ],
      }
    },
    {
      path: '/settings/ai-settings',
      name: 'settings.aisettings',
      beforeEnter: checkAiAuth,
      component: () => import('@/components/settings/ai-settings/Index.vue'),
      meta: {
        title: '_aisettings.ai settings',
        suffix: titleSuffix,
        name: 'AI Settings',
        link: 'settings/ai-settings',
        breadcrumb: [
          { name: "Settings", link: "/settings" },
          { name: "_aisettings.ai settings", link: "/settings/ai-settings" }
        ]
      }
    },
    {
      path: '/backoffice/login',
      name: 'backoffice.login',
      beforeEnter : checkAuth,
      component: () => import('@/components/backoffice/auth/Login'),
      meta: { 
        layout: 'auth-layout'
       }
    },
    {
      path: '/backoffice/home',
      beforeEnter : checkAuth,
      component: () => import('@/components/backoffice/home/Index.vue'),
      name: 'backoffice.home',
      meta: {
        layout: 'backoffice-layout',
        title: 'Home',
        icon: 'fas fa-home',
        suffix: titleSuffix,
        link: '/backoffice/home',
      }
    },
    {
      path: '/backoffice/orders',
      beforeEnter : checkAuth,
      component: () => import('@/components/backoffice/orders/Index.vue'),
      name: 'backoffice.orders',
      meta: {
        layout: 'backoffice-layout',
        title: 'Orders',
        icon: 'fas fa-shopping-basket',
        suffix: titleSuffix,
        link: '/backoffice/orders',
      }
    },
    {
      path: '/backoffice/webhooklog',
      beforeEnter : checkAuth,
      component: () => import('@/components/backoffice/webhookLog/Index.vue'),
      name: 'backoffice.webhooklog',
      meta: {
        layout: 'backoffice-layout',
        title: 'Webhook Log',
        icon: 'fas fa-cogs',
        suffix: titleSuffix,
        link: '/backoffice/webhooklog',
        breadcrumb: [
          { name: "Webhook Log" }
        ],
      }
    },
    {
      path: '/backoffice/externallog',
      beforeEnter : checkAuth,
      component: () => import('@/components/backoffice/externalLog/Index.vue'),
      name: 'backoffice.externallog',
      meta: {
        layout: 'backoffice-layout',
        title: 'External Log',
        icon: 'fas fa-external-link-square-alt',
        suffix: titleSuffix,
        link: '/backoffice/externallog',
      }
    },
    {
      path: '/backoffice/users',
      beforeEnter : checkAuth,
      component: () => import('@/components/backoffice/users/Index.vue'),
      name: 'backoffice.users',
      meta: {
        layout: 'backoffice-layout',
        title: 'Users',
        icon: 'fas fa-users',
        suffix: titleSuffix,
        link: '/backoffice/users',
      }
    },
    {
      path: '/backoffice/pages',
      beforeEnter : checkAuth,
      component: () => import('@/components/backoffice/pages/Index.vue'),
      name: 'backoffice.pages',
      meta: {
        layout: 'backoffice-layout',
        title: 'Pages',
        icon: 'fas fa-file',
        suffix: titleSuffix,
        link: '/backoffice/pages',
      }
    },
    {
      path: '/backoffice/reports',
      beforeEnter : checkAuth,
      component: () => import('@/components/backoffice/reports/Index.vue'),
      name: 'backoffice.reports',
      meta: {
        layout: 'backoffice-layout',
        title: 'Reports',
        icon: 'fas fa-file-alt',
        suffix: titleSuffix
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/components/auth/AutoLogin'),
      meta: {
        layout: 'auth-layout'
      }
    },
    {
      path: '/login/auth/:request_id/:token',
      redirect: to => {
        // the function receives the target route as the argument
        // we return a redirect path/location here.
        return { path: '/login/auth', query: { request_id: to.params.request_id, token: to.params.token } }
      },
    },
    {
      path: '/login/auth',
      name: 'auto.login',
      component: () => import('@/components/auth/AutoLogin'),
      meta: {
        layout: 'auth-layout'
      }
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('@/components/auth/Index'),
      meta: {
        layout: 'auth-layout'
      }
    },
    {
      path: '/gosaas-connect',
      name: 'gosaas-connect',
      beforeEnter : checkAuth,
      component: () => import('@/components/gosaas-connect/Index'),
      meta: {
        layout: 'auth-layout'
      }
    },
    {
      path: '*',
      beforeEnter : checkAuth,
      component: () => import('@/components/chat/Index'),
      meta: {
        layout: 'social-layout-no-header',
        title: 'All chat',
        icon: '',
        // breadcrumb: [
        //     { name: "Social Commerce", link: "/live" },
        //     { name: "Live" }
        // ],
        suffix: titleSuffix
      }
    },
    {
      path: '/',
      beforeEnter : checkAuth,
      component: () => import('@/components/chat/Index'),
      meta: {
        layout: 'social-layout-no-header',
        title: 'All chat',
        icon: '',
        // breadcrumb: [
        //     { name: "Social Commerce", link: "/live" },
        //     { name: "Live" }
        // ],
        suffix: titleSuffix
      }
    },
    {
      path: '/chat/all',
      name: 'chat.all',
      props: true,
      beforeEnter : checkAuth,
      component: () => import('@/components/chat/Index'),
      meta: {
        layout: 'social-layout-no-header',
        title: 'All chat',
        icon: '',
        // breadcrumb: [
        //     { name: "Social Commerce", link: "/live" },
        //     { name: "Live" }
        // ],
        suffix: titleSuffix
      }
    },
    {
      path: '/chat/facebook',
      name: 'chat.facebook',
      beforeEnter : checkAuth,
      component: () => import('@/components/chat/Index'),
      meta: {
        title: 'Facebook',
        icon: '',
        // breadcrumb: [
        //     { name: "Social Commerce", link: "/live" },
        //     { name: "Live" }
        // ],
        suffix: titleSuffix
      }
    },
    {
      path: '/chat/messenger',
      name: 'chat.messenger',
      beforeEnter : checkAuth,
      component: () => import('@/components/chat/Index'),
      meta: {
        layout: 'social-layout-no-header',
        title: 'Messenger',
        icon: '',
        // breadcrumb: [
        //     { name: "Social Commerce", link: "/live" },
        //     { name: "Live" }
        // ],
        suffix: titleSuffix
      }
    },
    {
      path: '/chat/direct-message',
      name: 'chat.direct-message',
      beforeEnter : checkAuth,
      component: () => import('@/components/chat/Index'),
      meta: {
        layout: 'social-layout-no-header',
        title: 'Direct Messenger',
        icon: '',
        // breadcrumb: [
        //     { name: "Social Commerce", link: "/live" },
        //     { name: "Live" }
        // ],
        suffix: titleSuffix
      }
    },
    {
      path: '/chat/line',
      name: 'chat.line',
      beforeEnter : checkAuth,
      component: () => import('@/components/chat/Index'),
      meta: {
        layout: 'social-layout-no-header',
        title: 'Line',
        icon: '',
        // breadcrumb: [
        //     { name: "Social Commerce", link: "/live" },
        //     { name: "Live" }
        // ],
        suffix: titleSuffix
      }
    },
    {
      path: '/chat/tiktok',
      name: 'chat.tiktok',
      beforeEnter : checkAuth,
      component: () => import('@/components/chat/Index'),
      meta: {
        layout: 'social-layout-no-header',
        title: 'Tiktok',
        icon: '',
        // breadcrumb: [
        //     { name: "Social Commerce", link: "/live" },
        //     { name: "Live" }
        // ],
        suffix: titleSuffix
      }
    },
    {
      path: '/customer',
      name: 'customer',
      beforeEnter : checkAuth,
      component: () => import('@/components/customer/Index'),
      meta: {
        layout: 'social-layout',
        header: true,
        title: 'Customers',
        icon: '',
        breadcrumb: [
          { name: "Customers" }
        ],
        suffix: titleSuffix
      }
    },
    {
      path: '/reports',
      name: 'reports',
      beforeEnter : checkAuth,
      component: () => import('@/components/report/Index'),
      meta: {
        layout: 'social-layout',
        header: true,
        title: 'Reports',
        icon: '',
        breadcrumb: [
          { name: "Reports" }
        ],
        suffix: titleSuffix
      }
    },
    {
      path: '/report/conversions-api',
      name: 'report.conversions.API',
      beforeEnter : checkAuth,
      component: () => import('@/components/report/conversionsAPI/Index'),
      meta: {
        layout: 'social-layout',
        header: true,
        title: 'Reports',
        icon: '',
        breadcrumb: [
          { name: 'Reports', link: "/reports" },
          { name: 'Conversions API Report' }
        ],
        suffix: titleSuffix
      }
    },
    {
      path: '/chat/shopee',
      name: 'chat.shopee',
      beforeEnter : checkAuth,
      component: () => import('@/components/chat/Index'),
      meta: {
        layout: 'social-layout-no-header',
        title: 'Shopee',
        icon: '',
        // breadcrumb: [
        //     { name: "Social Commerce", link: "/live" },
        //     { name: "Live" }
        // ],
        suffix: titleSuffix
      }
    },
    {
      path: '/chat/lazada',
      name: 'chat.lazada',
      beforeEnter : checkAuth,
      component: () => import('@/components/chat/Index'),
      meta: {
        layout: 'social-layout-no-header',
        title: 'Lazada',
        icon: '',
        // breadcrumb: [
        //     { name: "Social Commerce", link: "/live" },
        //     { name: "Live" }
        // ],
        suffix: titleSuffix
      }
    },
    {
      path: '/live',
      name: 'live.list',
      beforeEnter : checkAuth,
      component: () => import('@/components/live/LiveList'),
      meta: {
        title: 'Live',
        icon: '',
        // breadcrumb: [
        //     { name: "Social Commerce", link: "/live" },
        //     { name: "Live" }
        // ],
        suffix: titleSuffix
      }
    },
    {
      path: '/live/view/:id',
      name: 'live.view',
      beforeEnter : checkAuth,
      component: () => import('@/components/live/LiveView'),
      meta: {
        title: 'Manage Live',
        icon: '',
        // breadcrumb: [
        //     { name: "Social Commerce" },
        //     { name: "Live", link: "/live" },
        //     { name: "Manage Live" }
        // ],
        suffix: titleSuffix
      }
    },
    {
      path: '/connection',
      name: 'social.connection',
      beforeEnter : checkAuth,
      component: () => import('@/components/connection/Index'),
      meta: {
        title: 'Connection',
        icon: '',
        breadcrumb: [{ name: 'Social Commerce' }, { name: 'Connection' }],
        suffix: titleSuffix
      }
    },
    {
      path: '/auto-reply/inbox-comment',
      name: 'auto-reply.inbox-comment',
      beforeEnter : checkAuth,
      component: () => import('@/components/auto-reply/inbox-comment/Index'),
      meta: {
        title: 'Inbox & Comment',
        icon: '',
        breadcrumb: [{ name: 'Auto Reply' }, { name: 'Inbox & Comment' }],
        suffix: titleSuffix
      }
    },
    {
      path: '/auto-reply/live-message',
      name: 'auto-reply.live-message',
      beforeEnter : checkAuth,
      component: () => import('@/components/auto-reply/live-message/Index'),
      meta: {
        title: 'Live Message',
        icon: '',
        breadcrumb: [{ name: 'Auto Reply' }, { name: 'Live Message' }],
        suffix: titleSuffix
      }
    },
    {
      path: '/audience',
      name: 'audience',
      beforeEnter : checkAuth,
      component: () => import('@/components/audience/Index'),
      meta: {
        title: 'Audience',
        icon: '',
        breadcrumb: [{ name: 'Audience' }],
        suffix: titleSuffix
      }
    },
    {
      path: '/broadcast',
      name: 'broadcast',
      beforeEnter : checkAuth,
      component: () => import('@/components/broadcast/Index'),
      meta: {
        title: 'Broadcast',
        icon: '',
        breadcrumb: [{ name: 'Broadcast' }],
        suffix: titleSuffix
      }
    },
    {
      path: '/line-liff',
      name: 'line.liff',
      beforeEnter : checkAuth,
      component: () => import('@/components/line-liff/index'),
      meta: {
        title: 'Line Liff',
        icon: '',
        suffix: titleSuffix
      }
    },
    {
      path: '/data-deletion/callback',
      name: 'fbcallback.deletion',
      component: () => import('@/components/public/fbcallback-deletion/index.vue'),
      meta: {
        layout: 'auth-layout',
        title: 'Callback Deletion',
        icon: '',
        suffix: titleSuffix
      }
    },
    // {
    //   path: '/callback-deletion',
    //   name: 'fbcallback.deletion',
    //   component: () => import('@/components/public/fbcallback-deletion/index.vue'),
    //   meta: {
    //     layout: 'auth-layout'
    //   }
    // },
    {
      path: '/403',
      name: 'Access Denied',
      component: () => import('@/components/error-page/403.vue'),
      meta: {
        title: 'Access Denied',
        icon: '',
        breadcrumb: [{ name: 'Access Denied' }],
        suffix: titleSuffix
      }
    },
    {
      path: '/:catchAll(.*)',
      name: 'Not Found',
      component: () => import('@/components/error-page/404.vue'),
      meta: {
        title: 'Not found',
        icon: '',
        breadcrumb: [{ name: 'Not Found' }],
        suffix: titleSuffix
      }
    },
  ]
})

// router.beforeEach((to, from, next) => { 
//   var isAuthenticated = false;
//   var token = Cookies.get('centralToken');
//   console.log("cookies: ", token, to, to.matched)
//   if (token) isAuthenticated = true
//   else isAuthenticated = false
//   if(isAuthenticated) next();
//   else next('/login');
// })

async function checkAiAuth(to, from, next) {
  const token = Cookies.get('centralToken');
  if (!token) return next('/login');
  try {
    const res = await axios.get(process.env.API_URL + '/v2/settings/ai', {
      headers: { Authorization: `Bearer ${token}` }
    });
    if (res.data && res.data.success) return next();
  } catch (e) {
    // 403 = feature not available for this merchant, other errors = treat as unavailable
  }
  return next('/settings');
}

function checkAuth(to, from, next) {
  var isAuthenticated = false;
  var isBackofficeAuthenticated = false;
  var token = Cookies.get('centralToken');
  var backofficetoken = Cookies.get('backofficeToken');
  // console.log("auth: ", token)
  if (token) isAuthenticated = true
  else isAuthenticated = false
  if (backofficetoken) isBackofficeAuthenticated = true;
  else isBackofficeAuthenticated = false;
  if (to.name.includes("backoffice")) {
    if (isBackofficeAuthenticated || to.name == "backoffice.login") {
      next(); // allow to enter route
    } else {
      next('/backoffice/login'); // go to '/backoffice/login';
    }
  } else {
    if (isAuthenticated) {
      next(); // allow to enter route
    } else {
      next('/login'); // go to '/login';
    }
  }
}

// export default router



// WEBPACK FOOTER //
// ./src/router/index.js